import { atom, useRecoilState } from 'recoil';
import { ManeuverInput } from '@kinetic-ui/data-layer';
import { recoilKeys } from 'const';

export const selectedManeuverState = atom<ManeuverInput | undefined>({
  key: recoilKeys.SELECTED_MANEUVER,
  default: undefined,
});

export const useSelectedManeuver = () => {
  const [selectedManeuver, setSelectedManeuver] = useRecoilState(selectedManeuverState);

  return { selectedManeuver, setSelectedManeuver };
};
